<i18n src="@/locales/components/RequestNotificationStepsConfigTranslate.json"></i18n>

<template>
	<div class="step-config">
		<ul class="step-config__header inline-flex">
			<li :class="['cursor-pointer text-black text-center px-3 sm:px-6 py-3', { 'is-active font-bold': activeIndex === 0 }]" @click="activeIndex = 0">
				{{ $t("Approver") }}
			</li>
			<li :class="['cursor-pointer text-black text-center px-3 sm:px-6 py-3', { 'is-active font-bold': activeIndex === 1 }]" @click="activeIndex = 1">
				{{ $t("ApprovedNotifications") }}
			</li>
			<li :class="['cursor-pointer text-black text-center px-3 sm:px-6 py-3', { 'is-active font-bold': activeIndex === 2 }]" @click="activeIndex = 2">
				{{ $t("RejectedNotifications") }}
			</li>
		</ul>
		<div class="step-config__content p-5 border-solid border border-gray-5">
			<step-notification-config
				v-show="activeIndex === 0"
				v-model="value.approversConfig"
				formName="approverConfig"
				:isReadonly="isReadonly"
				:isRequiredTarget="isRequired"
				:selectTargetTitle="$t('ApproverTarget')"
			/>

			<step-notification-config
				v-show="activeIndex === 1"
				v-model="value.approvedNotificationConfig"
				formName="approvedNotificationConfig"
				:isReadonly="isReadonly"
				:selectTargetTitle="$t('ReceiverNotificationTarget')"
			/>

			<step-notification-config
				v-show="activeIndex === 2"
				v-model="value.rejectedNotificationConfig"
				formName="rejectedNotificationConfig"
				:isReadonly="isReadonly"
				:selectTargetTitle="$t('ReceiverNotificationTarget')"
			/>
		</div>
		<div class="mt-4">
			<legend>{{ $t("GuideDescription") }}:</legend>
			<cbs-editor v-model="value.description" />
		</div>
		<div class="mt-4">
			<label for="config-req-color" > Màu sắc</label>
			<cbs-input
							class="w-full"
							data-vv-delay="1"
							name="request-purpose"
							v-model="value.color"
							:data-vv-as="'Màu đại diện'"
							:placeholder="'Màu đại diện'"
						/>
		</div>
		<div class="mt-4">
			<input id="config-req-approver-fill" type="checkbox" v-model="value.approverFillInfo">
			<label for="config-req-approver-fill" > {{ $t("ApproverIsFillInfo") }}</label>
		</div>
	</div>
</template>

<script>
import StepNotificationConfig from "./StepNotificationConfig";
import CbsEditor from "@/components/cbs-editor/CbsEditor";

export default {
	name: "RequestNotificationConfig",
	components: { StepNotificationConfig, CbsEditor },
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop => {
				return prop.hasOwnProperty("approversConfig") && prop.hasOwnProperty("approvedNotificationConfig") && prop.hasOwnProperty("rejectedNotificationConfig");
			}
		},
		isReadonly: {
			type: Boolean,
			default: false
		},
		isRequired: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			activeIndex: 0
		};
	}
};
</script>

<style lang="scss" scoped>
.step-config {
	.step-config__header {
		border-left: 1px solid var(--color-gray-5);
		border-right: 1px solid var(--color-gray-5);
		position: relative;
		bottom: -1px;

		li {
			border-left: 1px solid var(--color-gray-5);
			border-top: 1px solid var(--color-gray-5);
			border-bottom: 1px solid var(--color-gray-5);

			&:first-child {
				border-left: 0;
			}

			&.is-active {
				border-bottom-color: #fff;
			}
		}
	}
}
</style>
